/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Template_Master_FormatsInputs */



/**
* | output |
* | --- |
* | "PowerPoint template (.potx), or .pptx" |
*
* @param {Presentation_Template_Master_FormatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_master_formats = /** @type {((inputs?: Presentation_Template_Master_FormatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Master_FormatsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("PowerPoint-Vorlage (.potx) oder .pptx")
	return /** @type {LocalizedString} */ ("PowerPoint template (.potx), or .pptx")
});